module.exports = __webpack_public_path__ + "@/assets/img/benefits-icon.31370b28.svg";